<template>
    <a-drawer :title="title" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="证书名称" prop="name">
                <a-input v-model="field.name" placeholder="请填写证书名称" />
            </a-form-model-item>
            <a-form-model-item label="证书编号" prop="sno">
                <a-input v-model="field.sno" placeholder="请填写证书编号" />
            </a-form-model-item>
            <a-form-model-item label="证书级别" prop="grade">
                <a-radio-group v-model="field.grade" button-style="solid">
                    <template v-for="(val, key) in $enums.CertGrade">
                        <a-radio-button :value="key" :key="key">
                            {{ val }}
                        </a-radio-button>
                    </template>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="证书类型" prop="type">
                <a-select v-model="field.type" placeholder="请选择证书类型">
                    <template v-for="(val, key) in $enums.CertType">
                        <a-select-option :value="key" :key="key" v-if="key.startsWith('UT')">
                            {{ val }}
                        </a-select-option>
                    </template>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="证书等级" prop="level">
                <a-input v-model="field.level" placeholder="请填写证书等级" />
            </a-form-model-item>
            <a-form-model-item label="发证单位" prop="munit">
                <a-input v-model="field.munit" placeholder="请填写发证单位" />
            </a-form-model-item>
            <a-form-model-item label="联合单位" prop="eunit">
                <a-input v-model="field.eunit" placeholder="请填写联合单位" />
            </a-form-model-item>
            <a-row :gutter="10">
                <a-col :span="12">
                    <a-form-model-item label="签发日期" prop="indate">
                        <a-date-picker v-model="field.indate" placeholder="请选择签发日期" value-format="YYYY-MM-DD" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="截至日期" prop="expire">
                        <a-date-picker v-model="field.expire" placeholder="请选择截至日期" value-format="YYYY-MM-DD" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-form-model-item label="证书图片" prop="imgs">
                <ImagesUpload type="CertImg" v-if="show" :imgs.sync="field.imgs"></ImagesUpload>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="execSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
import ImagesUpload from '@/comp/ImagesUpload'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    components: {
        ImagesUpload
    },
    data() {
        return {
            field: {
                id: '',
                name: '',
                sno: '',
                type: 'UT01',
                level: '',
                munit: '',
                eunit: '',
                grade: 'NA',
                indate: '',
                expire: '',
                imgs: ''
            },
            rules: {
                name: [{ required: true, message: '请填写证书名称', trigger: 'blur' }],
                sno: [{ required: true, message: '请填写证书编号', trigger: 'blur' }],
                type: [{ required: true, message: '请选择证书类型', trigger: 'change' }],
                grade: [{ required: true, message: '请选择证书级别', trigger: 'change' }],
                level: [{ required: true, message: '请填写证书等级', trigger: 'blur' }],
                munit: [{ required: true, message: '请填写发证单位', trigger: 'blur' }],
                indate: [{ required: true, message: '请选择签发日期', trigger: 'change' }],
                expire: [{ required: true, message: '请选择截至日期', trigger: 'change' }],
                imgs: [{ required: true, message: '请上传证书图片', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
    },
    methods: {
        execSave() {
            if (this.item.audit && (this.item.audit.state === 'Pass' || this.item.audit.state === 'Expire')) {
                this.$confirm({
                    title: '该证书已通过审核，重新编辑将需要再次审核，是否继续保存',
                    content: '证书：[' + this.item.name + ']',
                    okText: '确认保存',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk: () => {
                        this.doSave()
                    }
                })
            } else {
                this.doSave()
            }
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/crs/cert/unit/info/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
